export const ErrorAction = {
  dialogControls: "dialogControls",
};

export const ErrorMutation = {
  SET_DIALOG_CONTROLS: "SET_DIALOG_CONTROLS",
};
